const PdfFiles =

  [


    {
      "id": "slbphy1",
      "name": "syllabus-physics",
      "type": "syllabus",
      "subject": "physics",
      "topic": "SP",
      "pdfPath": "slbphy27.pdf"
    },
    {
      "id": "slbche1",
      "name": "syllabus-chemistry",
      "type": "syllabus",
      "subject": "chemistry",
      "topic": "SC",
      "pdfPath": "slbche27.pdf"
    },
    {
      "id": "slbmath1",
      "name": "syllabus-mathematics",
      "type": "syllabus",
      "subject": "mathematics",
      "topic": "SM",
      "pdfPath": "slbmath27.pdf"
    },



  ]

  export default PdfFiles;